import './App.css'
import { Route, Routes } from 'react-router-dom';
import Container from "./Components/Container/Container";
import HomePage from "./Pages/HomePage.jsx";
import InstitutionDetail from "./Pages/InstitutionDetail";
import Shkollat from "./Pages/Shkollat";
import Praktika from "./Pages/Praktika";
import {Provider} from "react-redux";
import {store} from "./redux/app/store";
import SearchResult from "./Pages/SearchResult";
import ErrorPage from "./Pages/ErrorPage";
import ArsimiIMesem from "./Pages/ArsimiIMesem";
import AftesiNdryshe from "./Pages/AftesiNdryshe";
import HowToApply from "./Pages/HowToApply";
import BursaTransport from "./Pages/BursaTransport";
import Community from "./Pages/Community";
import Dormitory from "./Pages/Dormitory";
import LearningAndPractice from "./Pages/LearningAndPractice";
import CampusesAndSocialLife from "./Pages/CampusesAndSocialLife";
import NewProfessional from "./Pages/NewProfessional";
import CareerAdvice from "./Pages/CareerAdvice";
import Drejtime from "./Pages/Drejtime";
import DegreeDetail from "./Pages/DegreeDetail";
import StudentDual from "./Pages/StudentDual.jsx";
import LegalBase from "./Pages/LegalBase.jsx";
import Statistics from "./Pages/Statistics";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsAndConditions from './Pages/TermsAndConditions';
import FindInstitution from "./Pages/FindInstitution.jsx";
import GjejDrejtimin from "./Pages/FindDirection.jsx";
import EmployeeDual from "./Pages/EmployeeDual";
import PracticeDual from "./Pages/PracticeDual";
import ProfessionalSystem from "./Pages/ProfessionalSystem";
import SingleDualBlog from "./Pages/SingleDualBlog";
import DualEducationInfo from "./Pages/DualEducationInfo";
import ProfessionalQualification from "./Pages/ProfessionalQualification";
import ArsimiDual from "./Components/dual/ArsimiDual";
import Punedhenes from "./Components/dual/Punedhenes";
import NxenesPunemarres from "./Components/dual/NxenesPunemarres";
import KualifikimDual from "./Components/dual/KualifikimDual";
import SubjectDetail from "./Components/dual/SubjectDetail";

function App() {
    return (
        <>
            <Provider store={store}>
                <Container>
                    <Routes>
                        <Route exact path="/" element={<HomePage/>}/>
                        <Route exact path="/shkollat-e-mesme-profesionale/:id" element={<InstitutionDetail/>}/>
                        <Route exact path="/formation-centers/:id" element={<InstitutionDetail/>}/>
                        <Route exact path="/shkollat" element={<Shkollat/>}/>
                        <Route exact path="/profesionist-i-ri" element={<NewProfessional/>}/>
                        <Route exact path="/praktika" element={<Praktika/>}/>
                        <Route exact path="/search-result/" element={<SearchResult/>}/>
                        <Route exact path="/si-te-aplikosh/" element={<HowToApply/>}/>
                        <Route exact path="/bursa-transport/" element={<BursaTransport/>}/>
                        <Route exact path="/arsimi-i-mesem" element={<ArsimiIMesem/>}/>
                        <Route exact path="/sistemi-profesional" element={<ProfessionalSystem/>}/>
                        <Route exact path="/aftesi-ndryshe" element={<AftesiNdryshe/>}/>
                        <Route exact path="/community" element={<Community/>}/>
                        <Route exact path="/campus-social-life" element={<CampusesAndSocialLife/>}/>
                        <Route exact path="/learning-practice" element={<LearningAndPractice/>}/>
                        <Route exact path="/dormitories" element={<Dormitory/>}/>
                        <Route exact path="/gjej-kualifikimin-profesional" element={<ProfessionalQualification/>}/>
                        <Route exact path="/career-advice" element={<CareerAdvice/>}/>
                        <Route exact path="/drejtime" element={<Drejtime/>}/>
                        <Route exact path="/drejtime/:id" element={<DegreeDetail/>}/>
                        <Route exact path="/punedhenesi-arsimi-dual" element={<EmployeeDual/>}/>
                        <Route exact path="/nxenesi-arsimi-dual" element={<StudentDual/>}/>
                        <Route exact path="/praktika-ne-sistemin-dual" element={<PracticeDual />}/>
                        <Route exact path="/blog/:id" element={<SingleDualBlog />}/>
                        <Route exact path="/baza-ligjore" element={<LegalBase/>}/>
                        <Route exact path="/intitucioni-arsimor" element={<FindInstitution/>}/>
                        <Route exact path="/gjej-drejtimin-profesional" element={<GjejDrejtimin/>}/>
                        <Route exact path="/statistics" element={<Statistics/>}/>
                        <Route exact path="/privacy-policy" element={<PrivacyPolicy/>}/>
                        <Route exact path="/terms-and-conditions" element={<TermsAndConditions/>}/>
                        <Route exact path="*" element={<ErrorPage/>}/>

                        <Route exact path="/dual" element={<ArsimiDual/>}/>
                        <Route exact path="/Punedhenes" element={<Punedhenes/>}/>
                        <Route exact path="/Nxenes Punemarres" element={<NxenesPunemarres/>}/>
                        <Route exact path="/KualifikimDual" element={<KualifikimDual/>}/>
                        <Route exact path="/dual-education-info" element={<DualEducationInfo/>}/>
                        <Route path="/subjekti/:id" element={<SubjectDetail />} />
                    </Routes>
                </Container>
            </Provider>
        </>
    );
}

export default App;
